import { useEffect, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import s from './styles/EventResult.module.scss';
import { Display } from '@/components/Display/Display';
import ResultLoading from './components/Loading/ResultLoading';
import resultImg from '@/assets/images/simulation/result_img.png';
import { pageProgressMap } from '@/utils/contants/caseSimulation';
import { curPageProgressIsCompleted, getToPathByStage } from './utils';
import GrtLoading from '@/components/Web/GrtLoading';

const EventResult = (props) => {
    let timerRef = useRef(null);
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    const { simulation } = props.store;
    let { eventResult = {}, setHeaderIcon, getApiProgress, pageProgress, getContent } = simulation;

    const goReport = () => {
        navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/review-report`, { replace: true });
    };

    useEffect(() => {
        setHeaderIcon({
            role: true,
            back: true,
            reStart: true
        });
    }, []);
    //清除定时器
    const clearTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };
    // const startTimer = () => {
    //     if (timerRef.current) {
    //         return;
    //     }
    //     timerRef.current = setInterval(() => {
    //         getApiProgress(caseId);
    //     }, 3000);
    // };
    const getProgress = async () => {
        let progress = await getApiProgress(caseId);
        let status = curPageProgressIsCompleted(progress, pageProgressMap['event_result_generating']);
        if (status === 'completed') {
            await getContent();
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            clearTimer();
        }
    };
    const startTimer = () => {
        if (timerRef.current) {
            return;
        }
        timerRef.current = setInterval(() => {
            getProgress();
        }, 3000);
    };

    //第一次进入页面的时候获取进度更改页面loading状态
    const getProgressInFirst = async () => {
        setPageLoading(true);
        let progress = await getApiProgress(caseId);
        let status = curPageProgressIsCompleted(progress, pageProgressMap['event_result_generating']);
        if (status === 'completed') {
            await getContent();
            setPageLoading(false);
        } else if (status === 'ing') {
            setLoading(true);
            setPageLoading(false);
            startTimer();
        } else {
            console.log('未完成');
            let path = getToPathByStage(pageProgress);
            console.log(path, '跳转了path');

            navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/${path}`, { replace: true });
        }
    };
    useEffect(() => {
        getProgressInFirst();
        return () => {
            clearTimer();
        };
    }, []);

    return (
        <>
            <div className={s['box-wrap']}>
                <Display show={pageLoading}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                        <GrtLoading />
                    </div>
                </Display>
                <Display show={!pageLoading}>
                    <>
                        <Display show={loading}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                <ResultLoading text="正在生成事件结果，请稍后" />
                            </div>
                        </Display>
                        <Display show={!loading}>
                            <div className={s['result-wrap']}>
                                <div className={`${s['result-wrap-shadow']}`}></div>

                                <div className={s['result-item-wrap']}>
                                    <img src={resultImg} alt="" />
                                    <div className={s['result-summary']}>{`“${eventResult?.title}”`}</div>
                                    <div className={s['result-item']}>
                                        <div className={s['title']}>【事件结果】</div>
                                        <div className={s['content']}>{eventResult?.event_result_summary}</div>
                                    </div>
                                    <div className={s['divider']}></div>
                                    <div className={s['result-item']}>
                                        <div className={s['title']}>【事件影响】</div>
                                        <div className={s['content']}>
                                            {eventResult &&
                                                eventResult?.event_impacts &&
                                                eventResult?.event_impacts.map((item, index) => {
                                                    return (
                                                        <div className={s['item']} key={index}>
                                                            {item}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                                <div onClick={goReport} className={s['result-btn']}>
                                    查看复盘报告
                                </div>
                            </div>
                        </Display>
                    </>
                </Display>
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(EventResult)));
